<template>
    <div>
        <div class="flex gap-x-4">
            <div class="bg-gray-200 px-6 py-2.5 text-xs text-gray-600">
                <i class="fas fa-exclamation-circle mr-1" />
                Apenas uma moeda pode ser sacada por vez
            </div>
            <primary-button
                @click.native="showModalWithdraw = true"
            >
                <i class="fas fa-plus mr-2" />Realizar novo saque
            </primary-button>
        </div>

        <jet-confirmation-modal
            :show="showModalWithdraw"
            :scroll="false"
            :animation="'top'"
            :position-modal="'center'"
            @close="showModalWithdraw = false"
        >
            <template #title>
                <div class="w-full">
                    <div class="text-black text-opacity-70 font-bold text-xl">
                        <i
                            v-show="!sectionsWithdraw.selectCoin"
                            class="p-2 text-gray-600 fas fa-arrow-left cursor-pointer"
                            @click="sectionsWithdraw.selectCoin = true"
                        />
                        Novo saque
                    </div>
                    <hr class="mt-1 w-full" />
                </div>
            </template>
            <template #content>
                <div
                    class="mt-2 transition-all ease-linear"
                    :class="!sectionsWithdraw.selectCoin ? 'h-56' : 'h-36'"
                >
                    <p class="text-sm text-gray-600 mt-3">
                        {{
                            sectionsWithdraw.selectCoin
                                ? "Selecione uma moeda para saque"
                                : "Selecione uma wallet para realização do saque"
                        }}
                    </p>
                    <div v-if="sectionsWithdraw.selectCoin" class="mt-4">
                        <jet-label :value="'Moeda'" class="ml-2" />
                        <auto-complete
                            :options-list="availableCoins"
                            :placeHolder="'Selecione uma moeda'"
                            v-model="form.selectedCoin"
                        />
                    </div>
                    <div v-else>
                        <div class="mt-4">
                            <jet-label :value="'Wallet'" class="ml-2" />
                            <dropdown-select
                                v-model="form.dest_wallet"
                                :options="returnWalletFromCurrency(form.selectedCoin.name)"
                                placeholder="Selecione a carteira"
                            />
                        </div>
                        <div class="mt-3">
                            <jet-label :value="'Valor do saque'" class="ml-2" />
                            <jet-decimal
                                :precision="valuePrecision"
                                v-model="form.crypto_amount"
                                class="mt-1 block w-full"
                            />
                        </div>
                    </div>

                    <div class="flex justify-between items-center mt-6 mb-4">
                        <span class="text-sm">Disponível para saque</span>
                        <div class="font-bold text-gray-600">
                            {{
                                form.selectedCoin?.value
                                    ? numberFormat(
                                        form.selectedCoin.value,
                                        form.selectedCoin.name
                                    )
                                    : "0,0000"
                            }}
                            {{ form.selectedCoin?.name ?? "" }}
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-between">
                    <secondary-button @click.native="showModalWithdraw = false">
                        Cancelar
                    </secondary-button>
                    <primary-button
                        :isDisabled="disabled"
                        @click.native="handleWithdraw"
                    >
                        {{
                            sectionsWithdraw.selectCoin
                                ? "Próximo"
                                : "Solicitar saque"
                        }}
                    </primary-button>
                </div>
            </template>
        </jet-confirmation-modal>

        <jet-confirmation-modal :show="showModalWithdrawError" :scroll="false" :position-modal="'center'">
            <template #title>
                <div class="w-full">
                    <div class="text-black text-opacity-70 font-bold text-xl">
                        <i
                            v-show="!sectionsWithdraw.selectCoin"
                            class="p-2 text-gray-600 fas fa-arrow-left cursor-pointer"
                            @click="
                                showModalWithdraw = true;
                                showModalWithdrawError = false;
                            "
                        />
                        Saque recusado
                    </div>
                    <hr class="mt-1 w-full" />
                </div>
            </template>
            <template #content>
                <div class="mt-2">
                    <p class="text-sm text-gray-600">
                        Este saque de <span class="font-bold">USDT</span> foi
                        rejeitado devido ao seguinte erro: <br /><br />
                        <span class="font-bold">
                            Instabilidade de conexão com a rede {{ form.selectedCoin?.network }}.
                        </span>
                        <br /><br />
                        Caso deseja reenviar o formulário clique em prosseguir se
                        não basta cancelar este processo nos botões abaixo, mas caso
                        queira entrar em contato com a nossa equipe de atendimento,
                        basta acesso os canais abaixo:
                    </p>
                    <div class="mt-4 text-sm font-bold text-gray-600">
                        <div class="my-4 flex bg-gray-100 py-3 rounded-md px-6">
                            <img
                                src="/images/whatsapp-brands.png"
                                class="w-6 mr-3 filter brightness-0"
                                alt=""
                            />
                            (11) 91234-5678
                        </div>
                        <div class="my-4 flex bg-gray-100 py-3 rounded-md px-6">
                            <img
                                src="/images/whatsapp-brands.png"
                                class="w-6 mr-3 filter brightness-0"
                                alt=""
                            />
                            atendimento@2gofintech.com.br
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-between">
                    <secondary-button
                        @click.native="showModalWithdrawError = false"
                    >
                        Cancelar
                    </secondary-button>
                    <primary-button :isDisabled="true">Confirmar</primary-button>
                </div>
            </template>
        </jet-confirmation-modal>
    </div>
</template>

<script>
import icons from "../utils/icons";
import numberFormat from "../utils/numberFormat";
import Icons from "../components/Icons.vue";
import DialogModal from "../../../Jetstream/DialogModal.vue";
import maskWithCommasAndDots from "../utils/maskInputWithCommaAndDots";
import DropdownSelect from "../components/DropdownSelect.vue";
import LabelForm from "../components/Label.vue";
import JetDecimal from "../../../Jetstream/Decimal.vue";
import ActionButton from "../../../Jetstream/Button.vue";
import SecondaryButton from "../../../Jetstream/SecondaryButton.vue";
import PrimaryButton from "../../../Jetstream/PrimaryButton.vue";
import JetConfirmationModal from "../../../Jetstream/ConfirmationModal.vue";
import AutoComplete from "../../../Jetstream/AutoComplete.vue";
import JetLabel from "../../../Jetstream/Label.vue";

export default {
    props: {
        available: { type: [Object, Array], default: () => ({}) },
        cryptos: { type: [Object, Array], default: () => ({}) },
    },
    data() {
        return {
            icons,
            numberFormat,
            selectValue: false,
            loadingCrypto: false,
            wallets: [],
            showModalWithdrawError: false,
            showModalWithdraw: false,
            sectionsWithdraw: {
                selectCoin: true,
            },
            form: this.$inertia.form({
                selectedCoin: null,
                dest_wallet: "",
                crypto_amount: ""
            }),
            balance: {
                total: 0,
                limit: 0,
                request_date: 0
            }
        };
    },
    computed: {
        availableCoins(){
            if (this.available === null) return []
            return Object.keys(this.available).map(key => ({
                id: key,
                name: key.toUpperCase(),
                value: this.available[key].remaining_amount
            })).filter(item => item.value)
        },
        disabled() {
            if(this.sectionsWithdraw.selectCoin && !this.form.selectedCoin) return true
            if(!this.sectionsWithdraw.selectCoin && !this.form.dest_wallet) return true
            if(!this.sectionsWithdraw.selectCoin){
                const value = Number(
                    this.form.crypto_amount?.replaceAll(".", "")?.replace(",", ".")
                );
                const total = this.form.selectedCoin?.value ?? 0;
                return !(this.form.crypto_amount && value > 0 && value <= total)
            }
            return false
        },
        valuePrecision() {
            return (
                this.cryptos.find(item => item.coin === this.form.selectedCoin?.name)
                    ?.decimal || 8
            );
        }
    },
    methods: {
        handleWithdraw() {
            if (this.sectionsWithdraw.selectCoin) {
                this.sectionsWithdraw.selectCoin = false
            } else {
                this.createOrder()
            }
        },
        createOrder() {
            const endpoint = "/crypto/withdraw";
            console.log(this.form);
            this.form.post(endpoint, {
                preserveState: false,
                resetOnSuccess: true
            });
        },
        formInputValueChange(val) {
            this.form.crypto_amount = maskWithCommasAndDots(
                val,
                this.valuePrecision
            );
        },
        returnWalletFromCurrency(currency = "BTC") {
            return (
                this.wallets?.list
                    .map(wallet => {
                        const currency = wallet.currency.toUpperCase();
                        return {
                            ...wallet,
                            currency,
                            name: `${wallet.name} - ${wallet.network}`
                        };
                    })
                    .filter(list => list.currency === currency) ?? []
            );
        },
        async getWallets() {
            const { data } = await axios.get("/crypto/wallet");
            this.wallets = data;
        }
    },
    created() {
        this.getWallets();
    },
    components: {
        Icons,
        DialogModal,
        DropdownSelect,
        LabelForm,
        JetDecimal,
        ActionButton,
        SecondaryButton,
        PrimaryButton,
        JetConfirmationModal,
        AutoComplete,
        JetLabel
    }
};
</script>
